const getTotalPercentage = list => {
  let total = list.reduce((total, num) => {
    return total + Number(num.Percentage);
  }, 0);
  return total;
};

export default getTotalPercentage;
